export default __webpack_public_path__ + "static/media/ic_cost.56371371.svg";